var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDownArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7781 6.36396L2.12125 0.707107C1.73073 0.316583 1.09756 0.316583 0.707036 0.707107C0.316512 1.09763 0.316512 1.7308 0.707036 2.12132L6.36389 7.77818C6.75441 8.1687 7.38758 8.1687 7.7781 7.77818C8.16863 7.38765 8.16863 6.75449 7.7781 6.36396Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0782 0.707329L6.4213 6.36418C6.03077 6.75471 6.03077 7.38787 6.4213 7.7784C6.81182 8.16892 7.44499 8.16892 7.83551 7.7784L13.4924 2.12154C13.8829 1.73102 13.8829 1.09785 13.4924 0.707329C13.1018 0.316804 12.4687 0.316804 12.0782 0.707329Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/down-arrow.3cb4e664.svg";
export { ForwardRef as ReactComponent };